import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { rebuildTasks } from '../../data/salesContent';
export function NextTrainingSection() {
  return <section className="bg-ink px-5 py-20 md:py-28" data-id="element-106" data-mp="1tfd0lu2zd951">
      <div className="mx-auto max-w-4xl" data-id="element-107" data-mp="1yfr7v9wrcf20">
        <SectionHeading title="Pensá en tu próxima capacitación" data-id="element-108" data-mp="1yezdg2ewcndb" />
        <p className="mt-10 text-center text-lg text-neutral-400 md:text-xl" data-id="element-109" data-mp="238aka3jpl458">Podés...</p>
        <ul className="mx-auto mt-6 grid max-w-3xl gap-3 sm:grid-cols-2" data-id="element-110" data-mp="285kc1puklrw8">
          {rebuildTasks.map(t => <li key={t} className="rounded-xl border border-ink-line px-5 py-4 text-lg text-neutral-500 line-through decoration-neutral-600 md:text-xl" data-id="element-111" data-mp="2c6m9c14xftvk">
              {t}
            </li>)}
        </ul>
        <p className="mt-12 text-center font-display text-4xl font-black text-gold md:text-5xl" data-id="element-112" data-mp="2m5ljjo5cbxko">O...</p>
        <p className="mt-6 text-center font-display text-2xl font-black uppercase leading-tight text-cream md:text-4xl" data-id="element-113" data-mp="mvdgbex1m74r">
          Podés empezar con gran parte del trabajo ya organizado.
        </p>
        <blockquote className="mx-auto mt-12 max-w-3xl border-l-4 border-gold pl-6 text-xl font-semibold italic leading-relaxed text-gold-light md:text-2xl" data-id="element-114" data-mp="2yubyk17jimke">
          Tu tiempo debería estar puesto en enseñar, no en reconstruir cada capacitación desde cero.
        </blockquote>
      </div>
    </section>;
}